// src/styles/index.ts
var THEME_CSS_IMPORT = "@aaimplatform/ui/styles/theme.css";
var THEME_STORAGE_KEY = "aaim-theme";
function asTheme(value) {
  return value === "light" || value === "dark" || value === "system" ? value : null;
}
function prefersDarkScheme() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}
function getStoredTheme() {
  if (typeof window === "undefined") return null;
  try {
    return asTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return null;
  }
}
function storeTheme(theme) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
  }
}
function resolveTheme(theme) {
  if (theme === "system") return prefersDarkScheme() ? "dark" : "light";
  return theme;
}
function getCurrentTheme() {
  if (typeof document === "undefined") return "light";
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}
function setTheme(theme) {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("dark", resolveTheme(theme) === "dark");
}
function applyTheme(theme) {
  const resolved = resolveTheme(theme);
  setTheme(resolved);
  storeTheme(theme);
  return resolved;
}
function applyStoredTheme() {
  const resolved = resolveTheme(getStoredTheme() ?? "system");
  setTheme(resolved);
  return resolved;
}
function toggleTheme() {
  if (typeof document === "undefined") return "light";
  const isDark = document.documentElement.classList.toggle("dark");
  return isDark ? "dark" : "light";
}
function subscribeToSystemTheme(callback) {
  if (typeof window === "undefined") return () => {
  };
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  const handler = (e) => callback(e.matches);
  mediaQuery.addEventListener("change", handler);
  return () => mediaQuery.removeEventListener("change", handler);
}

export {
  THEME_CSS_IMPORT,
  THEME_STORAGE_KEY,
  prefersDarkScheme,
  getStoredTheme,
  storeTheme,
  resolveTheme,
  getCurrentTheme,
  setTheme,
  applyTheme,
  applyStoredTheme,
  toggleTheme,
  subscribeToSystemTheme
};
